"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractParseTreeVisitor_1 = require("antlr4ts/tree/AbstractParseTreeVisitor");
const lodash_1 = require("lodash");
const errors_1 = require("../errors");
const arrayParser_1 = require("./arrayParser");
const assignmentParser_1 = require("./assignmentParser");
const bitwiseOpParser_1 = require("./bitwiseOpParser");
const comparatorParser_1 = require("./comparatorParser");
const conditionalParser_1 = require("./conditionalParser");
const functionCallParser_1 = require("./functionCallParser");
const identifierParser_1 = require("./identifierParser");
const intBinaryOpParser_1 = require("./intBinaryOpParser");
const logicalOpParser_1 = require("./logicalOpParser");
const pointerParser_1 = require("./pointerParser");
const postFixParser_1 = require("./postFixParser");
const primitiveParser_1 = require("./primitiveParser");
const stringParser_1 = require("./stringParser");
const unaryOpParser_1 = require("./unaryOpParser");
class BaseParser extends AbstractParseTreeVisitor_1.AbstractParseTreeVisitor {
    defaultResult() {
        return {
            type: 'EmptyExpression'
        };
    }
    visitParentheses(ctx) {
        return this.visit(ctx.expression());
    }
    visitChildren(node) {
        const expressions = [];
        for (let i = 0; i < node.childCount; i++) {
            expressions.push(node.getChild(i).accept(this));
        }
        return {
            type: 'SequenceExpression',
            expressions
        };
    }
    visitErrorNode(node) {
        throw new errors_1.FatalSyntaxError({
            start: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine
            },
            end: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine + 1
            }
        }, `invalid syntax ${node.text}`);
    }
}
const ParsingBehaviors = (0, lodash_1.flow)(comparatorParser_1.parserComparatorExpression, intBinaryOpParser_1.parserBinaryExpression, logicalOpParser_1.parserLogicalOpExpression, unaryOpParser_1.parserUnaryOpExpression, postFixParser_1.parserPostFixExpression, primitiveParser_1.parserPrimitiveExpression, bitwiseOpParser_1.parserBitwiseOpExpression, identifierParser_1.parserIdentifierExpression, assignmentParser_1.parserAssignmentExpression, arrayParser_1.parserArrayExpression, pointerParser_1.parserPointerExpression, functionCallParser_1.parserFunctionCallExpression, conditionalParser_1.parserConditionalExpression, stringParser_1.parserStringLiteral)(BaseParser);
class ExpressionParser extends ParsingBehaviors {
}
exports.default = ExpressionParser;
//# sourceMappingURL=index.js.map